import React, { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    TextField,
    SelectInput,
    required,
    NumberInput,
    ReferenceField,
    Datagrid,
    EditButton,
    Pagination, AutocompleteInput, ReferenceInput,
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { miniGradeTypes, miniGradeMiniCodes } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const MiniResultEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <TextInput name="metricKey" source="metricKey" validate={[required()]} />
                        <TextInput name="metricValue" source="metricValue"  />
                        <NumberInput name="metricValueNumeric" source="metricValueNumeric"  />
                    </Grid>
                    <Grid size={ 6 }>
                        <TextInput name="reasoning"
                                   source="reasoning"
                                   multiline
                                   rows={ 5 }
                                   validate={[required()]} />
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Mini Grade" }</span>
                            <ReferenceField source="miniGrade" reference="mini_grades" link="edit">
                                <TextField  source="name"/>
                            </ReferenceField>
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
